import React from "react";
import { useLoaderData } from "react-router-dom";
import useTitle from "../../../Hooks/useTitle";
import FeatureCard from "./FeatureCard";

const ProjectCaseStudy = () => {
  const projectDetails = useLoaderData();
  //   console.log(projectDetails);
  const {
    features,
    previewTxt,
    techStack,
    siteLink,
    clientCode,
    serverCode,
    timePeriod,
    projectName,
  } = projectDetails;
  useTitle(`Case Study of ${projectName}`);
  return (
    <div className="bg-primary h-full">
      <div className="container mx-auto pb-24">
        <div className="flex justify-center">{timePeriod}</div>
        <div className="flex lg:flex-row sm:flex-col flex-col lg:justify-between md:justify-between sm:justify-center justify-center items-center">
          <h2 className="text-accent lg:text-start md:text-center lg:text-6xl md:text-5xl sm:text-2xl text-2xl pb-10 font-semibold hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            {projectName}
          </h2>
          <div className="flex lg:justify-start md:justify-center gap-3 mb-6">
            <a
              href={siteLink}
              target="_blank"
              rel="noreferrer"
              className="text-green-400 border-b-green-400 text-sm border-b-2 hover:border-green-300 hover:text-green-300 transition-all ease-in-out duration-700 hover:cursor-pointer"
            >
              LIVE SITE
            </a>
            <a
              href={clientCode}
              target="_blank"
              rel="noreferrer"
              className="text-green-400 border-b-green-400 text-sm border-b-2 hover:border-green-300 hover:text-green-300 transition-all ease-in-out duration-700 hover:cursor-pointer"
            >
              CLIENT CODE
            </a>
            <a
              href={serverCode}
              target="_blank"
              rel="noreferrer"
              className="text-green-400 border-b-green-400 text-sm border-b-2 hover:border-green-300 hover:text-green-300 transition-all ease-in-out duration-700 hover:cursor-pointer"
            >
              SERVER CODE
            </a>
          </div>
        </div>
        <h2 className="lg:text-2xl md:text-xl sm:text-sm text-sm font-light text-success pb-2 hover:scale-110 hover:rotate-1 transition-all ease-in-out delay-75 duration-500 hover:text-yellow-500 lg:mx-0 md:mx-auto sm:mx-auto mx-auto sm:w-9/12">
          {previewTxt}
        </h2>
        <div className="flex justify-between items-center">
          <div className="flex gap-2 flex-wrap mt-4 mb-20">
            {techStack.map((tech) => (
              <div className="badge badge-outline badge-accent text-primary font-medium">
                {tech}
              </div>
            ))}
          </div>
        </div>
        <div>
          {features.map((feature) => (
            <FeatureCard feature={feature}></FeatureCard>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectCaseStudy;
